import { loadCatalogSchemesByClasses } from "src/business/catalog/apiCatalog";
import { ZSpecificationTyped } from "src/business/specification";

export const createCatalogSchemesByClassesLoader = (catalogId: string) => {
  const cache = new Map<string, ZSpecificationTyped[]>();

  return async (classIds: string[]): Promise<ZSpecificationTyped[]> => {
    if (classIds.length === 0) {
      return [];
    }

    const cacheKey = classIds.slice().sort().join(",");
    const cached = cache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const loaded = await loadCatalogSchemesByClasses(catalogId, classIds);
    cache.set(cacheKey, loaded);
    return loaded;
  };
};
